import { Injectable } from '@angular/core';
import { IKBCatalog, IKBArtifact } from '../interfaces/IBase-knowledge-catalog';

@Injectable({
  providedIn: 'root'
})
export class ChangeTrackerService {

  markCatalogAsChanged(catalog: IKBCatalog): void {
    catalog.HasChanges = true;
  }

  markArtifactAsChanged(artifact: IKBArtifact): void {
    artifact.HasChanges = true;
  }

  markCatalogAsUnchanged(catalog: IKBCatalog): void {
    catalog.HasChanges = false;

    if (catalog.KBArtifacts) {
      catalog.KBArtifacts.forEach(artifact => {
        this.markArtifactAsUnchanged(artifact);
      });
    }
  }

  markArtifactAsUnchanged(artifact: IKBArtifact): void {
    artifact.HasChanges = false;
  }

  hasCatalogChanges(catalog: IKBCatalog): boolean {
    return catalog.HasChanges === true;
  }

  hasArtifactChanges(artifact: IKBArtifact): boolean {
    return artifact.HasChanges === true;
  }

  getChangedCatalogs(catalogs: IKBCatalog[]): IKBCatalog[] {
    return catalogs.filter(catalog => this.hasCatalogChanges(catalog));
  }

  getChangedArtifacts(catalog: IKBCatalog): IKBArtifact[] {
    if (!catalog.KBArtifacts) {
      return [];
    }
    return catalog.KBArtifacts.filter(artifact => this.hasArtifactChanges(artifact));
  }

  initializeChangeTracking(catalog: IKBCatalog): void {
    catalog.HasChanges = false;
    if (catalog.KBArtifacts) {
      catalog.KBArtifacts.forEach(artifact => {
        artifact.HasChanges = false;
      });
    }
  }
}
